import Api from '../../services/Api';

export default {
  state: {
    videoLinks: [],
    videoLinksLoaded: false,
  },
  actions: {
    loadVideoLinks({ commit }) {
      Api.getVisionCategory()
        .then(r => r.data)
        .then(videoLinks => {
          commit('SET_VIDEO_LINKS', videoLinks);
        })
        .catch(error => {
          this.$log.error(error);
        });
    },
  },
  mutations: {
    SET_VIDEO_LINKS(state, videos) {
      state.videoLinks = videos;
      state.videoLinksLoaded = true;
    },
  },
  getters: {
    getVideoLinks: state => category => {
      var linksTmp = state.videoLinks;

      if (!linksTmp || linksTmp.length === 0) {
        return null;
      }

      var value = null;
      linksTmp.forEach(function(link) {
        if (link.name === category) {
          value = link.visions;
        }
      });

      return value;
    },

    isVideoLoaded: state => () => {
      return state.videoLinksLoaded;
    },

    getVideoLinkWithName: state => nameVideo => {
      var result = null;
      state.videoLinks.forEach(category => {
        category.visions.forEach(video => {
          if (video) {
            if (video.description === nameVideo) {
              result = video.url;
            }
          }
        });
      });
      return result;
    },
  },
};
